<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <!--<div class="note">(*) Nội dung không được bỏ trống</div>-->
        <formView
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import formView from './view_post_info'
export default {
  components: {
    formView
  },
  data() {
    return {
      validationErrors: [],
      title: "Post",
      mode: 'view',
      models: {},
      images: [],
      oldImages: [],
      componentKey: 0,
      page_transaction:null
    }
  },
  async mounted () {
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_REPORT_POST);
    if (this.mode == 'view'){
      if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-report-post' });
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('post', {"fields" : 
          `id type title caption active participation_fee currency_code number_of_mercenary number_recruit gender schedule abbout_club about_yourself age country_id attendance_check tag
          match{
            id date_time gender number_of_player_id participation_fee currency_code statdium_id 
            number_of_player{id code} 
            stadium{id name}
            competition_clubs{id club_name} name_club_competition competition_clubs_id
          } 
          clubs{id club_name}
          post_operating_time{operating_time {id operating_time_lang(where: {lang: {_eq: "en"}}){lang name}}}
          post_main_area{id province_id district_id province{id province_lang(where: {lang: {_eq: "en"}}){name}} district{id district_lang(where: {lang: {_eq: "en"}}){name}}}
        `}),
        variables: {
          where_key: {
            id: {'_eq': id}
          }
        },
        fetchPolicy: "network-only"
      })
      // console.log("datadata:",data);
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        var type_image = ""
        if(this.models.type =='POST_ON_MY_CLUB'){
          type_image = 'IMAGE_POST_MY_CLUB'
        }else if(this.models.type =='LOOKING_FOR_A_TEAM' || this.models.type =='LOOKING_FOR_MERCENARY' || this.models.type =='SCOUT_CLUB_TEAM_MEMBER' || this.models.type =='APPLYING_TO_JOIN'){
          type_image = 'IMAGE_POST_THE_MATCH'
        }else if(this.models.type =='MATCH' || this.models.type =='LIFE' || this.models.type =='SHOWING_OFF_YOUR_EQUIPMENT' || this.models.type =='QUESTION'){
          type_image = 'IMAGE_POST_COMMUNITY'
        }
        var {listData} = await this.$CoreService.getFile(type_image,this.models.id,0);
        if (listData.length > 0){
          var img_club = []
          for (let i = 0; i < listData.length; i++) {
            img_club.push({id : listData[i].id,url : listData[i].url})
          }
          this.models.img_club = listData
        }
      }
      this.componentKey++;
    },
  },
  
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ 
    /* padding: 24px; */
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;}
      }
      .box-images{ margin-top: 10px; position: relative;
        .item-img{height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative; border: 0.5px solid #ccc;
          &.p-col-5{width: 18% !important;}
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain;}
          .button-clear{width: 18px; height: 18px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 20px; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>
<style>
.list-group-v {
  /* display: -webkit-box;
   display: -ms-flexbox;*/
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  /*-ms-flex-direction: column;*/
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.list-group-item-v:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}
.list-group-item-v {
  position: relative;
  display: block;
  padding: .75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125) ;
  height: 50px;
}
.box-check-box{
  position: relative;
}
.box-check-box label{
  position: absolute;
  left: 0px;
  top: 2px;
}
.box-check-box .check-box-day{
  position: absolute;
  right: 0px;
  top: 2px;
}
.p-field{
  margin-bottom: 0.5rem!important;
}
</style>